import { RootState } from 'modules'

import { UserState } from './duck'

export const selectUser = (state: RootState): UserState => state.user
